// network ids used elsewhere
export const SEPOLIA_NETWORK_ID = 11155111;
export const ARBITRUM_SEPOLIA_NETWORK_ID = 421614;
export const BASE_SEPOLIA_NETWORK_ID = 84532;
export const GANACHE_NETWORK_ID = 1337;

export const SEPOLIA_FIRST_BLOCK = 5564000;
export const ARBITRUM_SEPOLIA_FIRST_BLOCK = 5500000;
export const BASE_SEPOLIA_FIRST_BLOCK = 12377600;
